"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteRole = exports.updateRole = exports.createRole = exports.fetchAllRoles = exports.fetchRoles = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reduxBatchedActions = require("redux-batched-actions");

var _actions = require("skybase-ui/skybase-core/base/actions");

var _actions2 = require("../actions");

var _rest = require("../rest");

var _actions3 = require("./actions");

var _constants = require("../constants");

var _utils = require("../utils");

var _rolesI18n = require("./roles-i18n");

var _messagesI18n = require("../messages-i18n");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var NORMAL = _constants.STATES.NORMAL,
    LOADING = _constants.STATES.LOADING;

var fetchRoles = function fetchRoles(pageSize, pageNumber, _) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      var _yield$getRolesApi, _yield$getRolesApi$re, roles, listConfig;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              dispatch((0, _actions3.changeListRolesState)(LOADING));
              _context.next = 4;
              return (0, _rest.getRolesApi)(pageSize, pageNumber);

            case 4:
              _yield$getRolesApi = _context.sent;
              _yield$getRolesApi$re = _yield$getRolesApi.records;
              roles = _yield$getRolesApi$re === void 0 ? [] : _yield$getRolesApi$re;
              listConfig = (0, _objectWithoutProperties2.default)(_yield$getRolesApi, ["records"]);
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changeListRolesState)(NORMAL), (0, _actions3.setRoles)(roles.map(function (role) {
                return _objectSpread(_objectSpread({}, role), {}, {
                  id: role.name
                });
              })), (0, _actions3.changeRoleListConfig)(listConfig)]));
              _context.next = 16;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              dispatch((0, _actions3.changeListRolesState)(NORMAL)); // todo handle errors

              console.log(_context.t0);
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _(_messagesI18n.messages.error),
                message: _(_rolesI18n.messages.errorDuringRolesFetch)
              }));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.fetchRoles = fetchRoles;

var fetchAllRoles = function fetchAllRoles(_) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      var _yield$getRolesApi2, _yield$getRolesApi2$r, roles;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _rest.getRolesApi)(10000, 1);

            case 3:
              _yield$getRolesApi2 = _context2.sent;
              _yield$getRolesApi2$r = _yield$getRolesApi2.records;
              roles = _yield$getRolesApi2$r === void 0 ? [] : _yield$getRolesApi2$r;
              dispatch((0, _actions3.setAllRoles)(roles.map(function (role) {
                return role.name;
              })));
              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _(_messagesI18n.messages.error),
                message: _(_rolesI18n.messages.errorDuringRolesFetch)
              }));

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.fetchAllRoles = fetchAllRoles;

var createRole = function createRole(role, _ref3, _) {
  var pageSize = _ref3.pageSize,
      pageNumber = _ref3.pageNumber;
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      var errorCode;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              dispatch((0, _actions3.changeCreateRoleState)(LOADING));
              _context3.next = 4;
              return (0, _rest.createRoleApi)(role);

            case 4:
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changeCreateRoleState)(NORMAL), (0, _actions3.clearCreateRoleParams)(), (0, _actions.closeModal)()]));
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_rolesI18n.messages.roleSuccessfullyCreated)
              }));
              dispatch(fetchRoles(pageSize, pageNumber, _));
              _context3.next = 19;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);
              dispatch((0, _actions3.changeCreateRoleState)(NORMAL));
              errorCode = (0, _utils.getErrorCode)(_context3.t0);
              _context3.t1 = errorCode;
              _context3.next = _context3.t1 === 409 ? 16 : 18;
              break;

            case 16:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _rolesI18n.messages.roleAlreadyExists
              }));
              return _context3.abrupt("break", 19);

            case 18:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _rolesI18n.messages.errorDuringRoleCreation
              }));

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 9]]);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.createRole = createRole;

var updateRole = function updateRole(role, _ref5, _) {
  var pageSize = _ref5.pageSize,
      pageNumber = _ref5.pageNumber;
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      var errorCode;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              dispatch((0, _actions3.changeUpdateRoleState)(LOADING));
              _context4.next = 4;
              return (0, _rest.updateRoleApi)(role);

            case 4:
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changeLoadedRoleId)(role.name), // updating the loaded state with new ID
              (0, _actions3.changeUpdateRoleState)(NORMAL), (0, _actions.closeModal)()]));
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_rolesI18n.messages.roleSuccessfullyUpdated)
              }));
              dispatch(fetchRoles(pageSize, pageNumber, _));
              _context4.next = 19;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              dispatch((0, _actions3.changeUpdateRoleState)(NORMAL));
              errorCode = (0, _utils.getErrorCode)(_context4.t0);
              _context4.t1 = errorCode;
              _context4.next = _context4.t1 === 409 ? 16 : 18;
              break;

            case 16:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _rolesI18n.messages.roleAlreadyExists
              }));
              return _context4.abrupt("break", 19);

            case 18:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _rolesI18n.messages.errorDuringRoleUpdate
              }));

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 9]]);
    }));

    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }();
};

exports.updateRole = updateRole;

var deleteRole = function deleteRole(name, _ref7, _) {
  var pageSize = _ref7.pageSize,
      pageNumber = _ref7.pageNumber;
  return /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return (0, _rest.deleteRoleApi)(name);

            case 3:
              dispatch((0, _actions3.clearAllRoleForms)());
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_rolesI18n.messages.roleSuccessfullyDeleted)
              }));
              dispatch(fetchRoles(pageSize, pageNumber, _));
              _context5.next = 12;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              // todo handle errors
              console.log(_context5.t0);
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _(_messagesI18n.messages.error),
                message: _(_rolesI18n.messages.errorDuringRoleDeletion)
              }));

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 8]]);
    }));

    return function (_x5) {
      return _ref8.apply(this, arguments);
    };
  }();
};

exports.deleteRole = deleteRole;
//# sourceMappingURL=utils.js.map